export const PersonnelTypes = {
    CLUB: "CLUB",
    VMS: "VMS",
    UMPIRE: "UMPIRE",
    RSA: "RSA",
    AUTHENTICATOR: "AUTHENTICATOR",
    ARCHIVE: "ARCHIVE",
};
